import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { Table } from '@/common/components/Table/component.tsx';
import { PageTitle } from '@/common/components/PageTitle/component.tsx';
import { ViewLayout } from '@/common/components/ViewLayout/component.tsx';
import { useSnapshotsProvider } from '@/common/providers/SnapshotsProvider/provider.tsx';
import { minifyString } from '@dor/utils';

import styles from './view.module.scss';

export const SnapshotsListView = () => {
  const snapshots = useSnapshotsProvider();

  useEffect(() => {
    snapshots.snapshots.fetch({}, {}, { pageSize: 10 });
  }, []);

  return (
    <ViewLayout>
      <PageTitle>All Snapshots</PageTitle>
      <div className={styles.information}>
        <Table
          className={styles.fullWidth}
          title="Snapshots"
          columns={[
            {
              key: 'ordinal',
              title: 'ordinal',
              style: 'link'
            },
            {
              key: 'hash',
              title: 'Hash'
            },
            {
              key: 'checkins',
              title: 'Device Check-ins'
            },
            { key: 'blocks', title: 'Currency Blocks' }
          ]}
          data={snapshots.snapshots.resource.resource.map((snapshot) => ({
            ordinal: (
              <Link to={`/snapshots/${snapshot.value.ordinal}`}>
                {snapshot.value.ordinal}
              </Link>
            ),
            hash: minifyString(snapshot.value.lastSnapshotHash),
            checkins: snapshot.deviceCheckins,
            blocks: snapshot.value.blocks.length
          }))}
          pagination={{
            currentPage: snapshots.snapshots.pagination.currentPage,
            pageSize: snapshots.snapshots.pagination.pageSize,
            totalPages: snapshots.snapshots.pagination.totalPages,
            totalItems: snapshots.snapshots.pagination.totalItems,
            onPageChange: (pageNumber) =>
              snapshots.snapshots.goToPage(pageNumber)
          }}
        />
      </div>
    </ViewLayout>
  );
};
